"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getThemeProps(params) {
  var theme = params.theme,
    name = params.name;
  if (!name || !theme.props || !theme.props[name]) {
    return {};
  }
  return theme.props[name];
}
var _default = getThemeProps;
exports.default = _default;